import { forwardRef, useState } from 'react';
import { Eye, EyeOff } from '../../../icons';
import { Input, type InputProps } from './Input';

/**
 * PasswordInput — 우측 보기 토글 (02-components.md B13).
 *
 * ★★ **`autoComplete` 를 «필수 props» 로 만들었다.** 비밀번호 칸에 이 값이 없으면 브라우저가
 *    새 비밀번호와 현재 비밀번호를 구분 못 해 엉뚱한 값을 채운다 — 그러고도 아무 경고가 없다.
 *    빼먹을 수 있는 것으로 두지 않고 타입이 막게 했다.
 * ★ 토글은 `aria-pressed` 로 «지금 보이는 중»을 말한다. 아이콘만 바뀌면 못 듣는다.
 */
export interface PasswordInputProps extends Omit<InputProps, 'type' | 'suffix' | 'autoComplete'> {
  autoComplete: 'current-password' | 'new-password' | 'off';
  showLabel?: string;
  hideLabel?: string;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(function PasswordInput(
  { showLabel = '비밀번호 보기', hideLabel = '비밀번호 숨기기', ...rest },
  ref,
) {
  const [shown, setShown] = useState(false);
  return (
    <Input
      ref={ref}
      type={shown ? 'text' : 'password'}
      suffix={
        <button
          type="button"
          className="wc-input__btn"
          onClick={() => setShown((v) => !v)}
          aria-pressed={shown}
          aria-label={shown ? hideLabel : showLabel}
        >
          {shown ? <EyeOff aria-hidden /> : <Eye aria-hidden />}
        </button>
      }
      {...rest}
    />
  );
});
